export let DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek["SUNDAY"] = "SUNDAY";
  DayOfWeek["MONDAY"] = "MONDAY";
  DayOfWeek["TUESDAY"] = "TUESDAY";
  DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
  DayOfWeek["THURSDAY"] = "THURSDAY";
  DayOfWeek["FRIDAY"] = "FRIDAY";
  DayOfWeek["SATURDAY"] = "SATURDAY";
  return DayOfWeek;
}({});
//# sourceMappingURL=time.js.map